import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import router from '../router'
import quickMessage from './modules/quickMessage';
import hardCode from './modules/hardCode';
import colors from 'vuetify/lib/util/colors';
import vuetify from '@/plugins/vuetify';
//import moment from "moment";

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: { quickMessage, hardCode },
  plugins: [createPersistedState()],
  getters : {
    isLoggedIn: state => !!state.user.authToken,
    authStatus: state => state.user.loggedInStatus,
  },
  state: {
    lookSoofia: false, // Si es soofia
    user: {
      Usu_Id: '',
      Emp_Id:'',
      Emp_Nombre: '',
      Emp_Imagen: '',
      name: '',
      loggedInStatus: false,
      authToken: '',
      Usu_Nombre: '',
      Usu_Apellido: '',
      Usu_Imagen: '',
      Roles: [],
      menu: [],
    },
    rules: {
      min: v => v.length >= 8 || 'Min 8 caracteres',
      min1: v => v.length >= 1 || 'Este campo es Requerido',
      required: v => !!v || 'Este dato es Requerido',
      requiredMultiple: v => v.length > 0 || 'Este dato es Requerido',
    },
    soofiaTheme: {
      primary: '#e9e9e9',
      secondary: '#f7f7f7',
      error: '#c37465',
      info: '#468bd1',
      success: '#46d147',
      warning: '#d16c46',
      purple: '#8453C9',
      'purple-variant': '#e7d6ff',
      'on-error': '#FFFFFF', // Color del texto en elementos secundarios
      'on-success': '#FFFFFF', // Color del texto en elementos secundarios
      'on-info': '#FFFFFF', // Color del texto en elementos secundarios
      'on-warning': '#FFFFFF', // Color del texto en elementos secundarios
    },
    oldTheme: {
      primary: '#7052fb',
      secondary: colors.grey.darken1,
      accent: colors.shades.black,
      error: colors.red.accent3,
      info: '#468bd1',
      success: '#46d147',
      warning: '#d16c46',
      purple: '#7052fb',
      'purple-variant': '#f2f3f8',
      'on-error': '#FFFFFF', // Color del texto en elementos secundarios
      'on-success': '#FFFFFF', // Color del texto en elementos secundarios
      'on-info': '#FFFFFF', // Color del texto en elementos secundarios
      'on-warning': '#FFFFFF', // Color del texto en elementos secundarios
    },
  },
  mutations: {
    addWebToken: (state, data) => {
      state.user.authToken = data.Use_Token;
      state.user.Usu_Id = data.Usu_Id;
      state.user.Emp_Id = data.Emp_Id;
      state.user.Emp_Nombre = data.Emp_Data.Emp_Nombre;
      state.user.Emp_Imagen = data.Emp_Data.Emp_Imagen;
      state.user.Usu_TieneClientes = data.Usu_TieneClientes;
      state.user.name = data.Usu_Nombre + ' ' + data.Usu_Apellido;
      state.user.Roles = data.Roles;
      state.user.Usu_Nombre = data.Usu_Nombre;
      state.user.Usu_Apellido = data.Usu_Apellido;
      state.user.Usu_Imagen = data.Usu_Imagen;
      state.user.menu = data.menuAdminEncuesta;
      state.lookSoofia = (!data.parameters?.soofia) ? false : data.parameters.soofia; // Si es soofia no se logea
      state.user.loggedInStatus = true;
    },
    removeWebToken: function (state) {
      state.user.authToken = '';
      state.user.Usu_Id = '';
      state.user.Emp_Id = '';
      state.user.Emp_Nombre = '';
      state.user.Emp_Imagen = '';
      state.user.name = '';
      state.user.menu = [];
      state.user.loggedInStatus = false;
    },
  },
  actions: {
    login: function (context, data) {
      if(context.getters.isLoggedIn)  context.commit('removeWebToken');
      return Vue.prototype.$http.post(process.env.VUE_APP_LOGIN_URI + 'login/by-token', { Use_Token: data.token, Usu_Id: data.usu_id})

        .then(function (response) {

          if (response.data.status === 'ok') {
            context.commit('addWebToken', response.data.data); // pass the webtoken as payload to the mutation
            context.dispatch('changeVuetifyTheme')
            console.log(response.data.data);
            let path = router.currentRoute.query?.path ?? ''
            router.push({ path: `/${path}` })
          }
          return response.data;
        });
    },
    logout: function (context) {
      context.commit('removeWebToken');
      router.push({
          path: '/',
      });
    },
    changeVuetifyTheme(context){
      var themeActual = (context.state.lookSoofia) ? 'soofiaTheme' : 'oldTheme'
      console.log('isSoofia:', themeActual, vuetify)
      vuetify.framework.theme.themes.light.primary = context.state[themeActual].primary;
      vuetify.framework.theme.themes.light.secondary = context.state[themeActual].secondary;
      vuetify.framework.theme.themes.light.error = context.state[themeActual].error;
      vuetify.framework.theme.themes.light.info = context.state[themeActual].info;
      vuetify.framework.theme.themes.light.success = context.state[themeActual].success;
      vuetify.framework.theme.themes.light.warning = context.state[themeActual].warning;
      vuetify.framework.theme.themes.light.purple = context.state[themeActual].purple;
      vuetify.framework.theme.themes.light['purple-variant'] = context.state[themeActual]['purple-variant'];
      vuetify.framework.theme.themes.light['on-error'] = context.state[themeActual]['on-error'];
      vuetify.framework.theme.themes.light['on-success'] = context.state[themeActual]['on-success'];
      vuetify.framework.theme.themes.light['on-info'] = context.state[themeActual]['on-info'];
      vuetify.framework.theme.themes.light['on-warning'] = context.state[themeActual]['on-warning'];
      
    }
  }
})

export default store;